export default function countdown(seconds: number, daysLetter: string): string {
  if (seconds <= 0) {
    return '00:00:00'
  }
  let s = seconds
  let m = 0
  let h = 0
  let d = 0
  if (s >= 60) {
    m = Math.floor(s / 60)
    s -= m * 60
    if (m >= 60) {
      h = Math.floor(m / 60)
      m -= h * 60
      if (h > 24) {
        d = Math.floor(h / 24)
        h -= d * 24
      }
    }
  }
  return `${d ? `${d}${daysLetter} ` : ''}${h > 9 ? '' : 0}${h}:${m > 9 ? '' : 0}${m}:${s > 9 ? '' : 0}${s}`
}
